import { Injectable } from '@angular/core';
import { APIService } from './api.service';


@Injectable({
    providedIn: 'root',
})

export class AddParkerEquipmentService {
    constructor(private readonly apiService: APIService) { }

    getGroupUserDriverList(req) {
        return this.apiService.postWithAllResponse('User/GetGroupUserDriverListByGroupUserId', req);
    }

    getAssignedGroupDriversByBookingId(req) {
        return this.apiService.postWithAllResponse('User/getAssignedGroupDriversByBookingId', req);
    }

    addGroupUsersDriver(req) {
        return this.apiService.postWithAllResponse('User/AddGroupUsersDriver', req);
    }

    deleteAssignedGroupBookingDriver(id){
        return this.apiService.delete('User/DeleteAssignedGroupBookingDriver',id)
      }

      assignGroupBookingDriver(req) {
        return this.apiService.postWithAllResponse('User/AssignGroupBookingDriver', req);
    }
    
    createNewVehicleForDriver(req){
        return this.apiService.postWithAllResponse('User/CreateNewVehicleForDriver',req)
      }

    getUnAssignedVehicleByGroupUserIdAndBookingId(req) {
    return this.apiService.get('User/GetUnAssignedVehicleByGroupUserIdAndBookingId', req);
  }

  shareGateAccessLink(req){
    return this.apiService.postWithAllResponse('BookingSlot/GenerateAndSendMailToAllAssociatedDriver',req)
  }
     
}